// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__166lQ","closeButton":"styles_closeButton__31GEC","title":"styles_title__351tI"};